import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Edit Experience", -1)
const _hoisted_4 = { class: "form_wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Experience", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    className: ['experience_modal'],
    width: "480px",
    height: "360px"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            onClick: $setup.onClickCloseButton
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            class: "c-input",
            density: "compact",
            placeholder: "20",
            min: 0,
            suffix: "Year(s)",
            modelValue: $setup.userExperience,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userExperience) = $event)),
            type: "number"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_v_btn, {
          class: "button button-orange",
          onClick: $setup.onClickSaveButton
        }, {
          default: _withCtx(() => [
            _createTextVNode("SAVE")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}